import { normalizeString } from '../functions';

const providerSchema = {
  name: (name) => normalizeString({ data: name, actions: ['spacing'] }),
  addressLine1: (addressLine1) =>
    normalizeString({ data: addressLine1, actions: ['spacing'] }),
  addressLine2: (addressLine2) =>
    normalizeString({ data: addressLine2, actions: ['spacing'] }),
  city: (city) => normalizeString({ data: city, actions: ['spacing'] }),
  state: (state) => normalizeString({ data: state, actions: ['spacing'] }),
  zip: (zip) => zip,
  externalId: (externalId) => (externalId ? externalId : ''),
};

export default providerSchema;
